module.exports = __webpack_public_path__ + "static/media/mg.18d64e09.svg";